import { FETCH_MOVIE, ONE_MOVIE, ONE_GENRE, CAST_MOVIE } from "./actionType";
// import Swal from "sweetalert2";

export const fetchMovie = function (payload) {
  return {
    type: FETCH_MOVIE,
    payload,
  };
};
export const oneMovie = function (payload) {
  return {
    type: ONE_MOVIE,
    payload,
  };
};
export const oneGenre = function (payload) {
  return {
    type: ONE_GENRE,
    payload,
  };
};
export const castMovie = function (payload) {
  return {
    type: CAST_MOVIE,
    payload,
  };
};

// https://moviesman.herokuapp.com
// http://localhost:3000
const baseUrl = "https://moviesman.herokuapp.com/customers/movie";

export const fetchMovies = function () {
  return (dispatch) => {
    fetch(`${baseUrl}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Masuk Error nih guys");
        }
        return res.json();
      })
      .then((data) => {
        // console.log(data, "<><><><><>");
        dispatch(fetchMovie(data.data));
        // console.log("masuk<<<<<<<<<");
      })
      .catch((err) => {
        console.log(err);
        // Swal.fire({
        //   title: "failed",
        //   icon: "error",
        //   text: err,
        //   confirmButtonText: "Ok",
        // });
      });
    // .finally(() => {
    //   setIsLoading(false);
    // });
  };
};

export const getMovie = function (id) {
  return (dispatch) => {
    fetch(`${baseUrl}/${id}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Masuk Error nih guys");
        }
        return res.json();
      })
      .then((data) => {
        dispatch(oneMovie(data.data.getOneMovie));
        dispatch(oneGenre(data.data.genreMovie));
        dispatch(castMovie(data.data.castMovie));
        // console.log(data, "<<<<<<<<");
      })
      .catch((err) => {
        console.log(err);
        console.log(err.message);
      });
  };
};
